import React from 'react';
import {ReactComponent as Loader} from '../../assets/spinner/spinner.svg';

const Spinner = props => {
    return (
        <Loader style={{width: props.size + 'px', height: props.size + 'px'}} />
    )
}

export default Spinner;
